var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cabecalho shadow-sm mb-2 bg-white"},[(_vm.ar.logo !=null)?_c('img',{staticClass:"logo",attrs:{"src":'data:image/png;base64,' +  _vm.ar.logo,"title":_vm.ar.name}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc58c8dc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cabecalho.vue
// module id = 257
// module chunks = 0